import { Component, OnInit } from '@angular/core';

import { confirm, alert } from 'devextreme/ui/dialog';
import { DevExtremeModule } from 'devextreme-angular';
import _ from 'lodash';
import { BaseDetailComponent } from 'app/shared/shared.module';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-families-detail',
    templateUrl: './families-detail.component.html',
    styleUrls: ['./families-detail.component.scss'],
    standalone: true,
    imports: [DevExtremeModule],
})
export class FamiliesInfosDetailComponent extends BaseDetailComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    familyId: number;
    family: any;
    familyInfo: any;

    key: string;
    members: any[];
    familyRelationships: any;
    states: any[];
    familyStatuses: any;
    households: any;
    canPrintStatement = false;
    photoUrl: string;
    serviceName = environment.serviceName;
    showAsDialog = false;

    closeRelativeUrl = '/people/families/';
    photos: any[];
    selectedPhoto: any;

    async ngOnInit() {
        const relationships = this.uow.lookups.relationships;
        const peopleStatuses = this.uow.lookups.peopleStatuses;
        this.familyStatuses = this.uow.lookups.familyStatuses;
        this.households = await this.uow.getHouseholds();
        this.states = await this.uow.getStates();

        await this.getFamily();

    }

    private async getFamily() {
        this.family = await this.utility.getFamilyInfos(this.familyId);
        this.familyInfo = this.family.familyInfo[0];
        if (!this.family) return;

        await this.getPhotos();
    }

    private async getPhotos() {
        const photos = await this.uow.photos.where('familyId', '==', this.familyId);
        this.photos = photos.map((photo: any) => {
            return { photo, url: this.utility.getPhoto(photo.fileName) };
        });
        const photo: any = _(this.photos).find((p) => p.photo.isDirectoryPhoto);
        if (photo) this.photoUrl = photo.url;
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    closeDialog() {
        if (this.showAsDialog) this.result.next({ success: false });
    }

}
